export default {
  set_exact(state, val) {
    state.commit("EXACT_VAL", val);
  },
};
